import { useEffect, useState } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, Building2, Target, Trophy } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { CTABand } from "@/components/site/CTABand";
import { Reveal } from "@/components/site/Reveal";
import api from "@/lib/api";

const BLOCKS = [
  { key: "challenge", label: "The Challenge", icon: Target },
  { key: "solution", label: "Our Solution", icon: Building2 },
  { key: "outcome", label: "The Outcome", icon: Trophy },
];

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const [c, setC] = useState(undefined);
  useEffect(() => { setC(undefined); api.getCaseStudy(slug).then(setC).catch(() => setC(null)); }, [slug]);

  if (c === null) return <Navigate to="/case-studies" replace />;
  if (!c) return <div className="min-h-screen" />;

  return (
    <div data-testid="case-study-detail-page">
      <PageHero
        breadcrumb={[{ label: "Case Studies", to: "/case-studies" }, { label: c.market }]}
        eyebrow={`${c.market} · ${c.service}`}
        title={c.title}
        intro={c.summary}
        image={c.image}
      />

      {/* Metrics */}
      <section className="border-y border-[color:var(--bp-border)]/50 bg-[color:var(--bp-bg-2)] py-12">
        <div className="container-bp grid grid-cols-1 gap-8 sm:grid-cols-3">
          {c.metrics.map((m) => (
            <Reveal key={m.label}>
              <div className="text-center">
                <p className="font-display text-4xl font-semibold text-[color:var(--bp-gold)] sm:text-5xl">{m.value}</p>
                <p className="mt-2 text-[13.5px] text-[color:var(--bp-text-muted)]">{m.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="section-py">
        <div className="container-bp max-w-3xl space-y-12">
          {BLOCKS.map((b, i) => (
            <Reveal key={b.key} delay={i * 0.05}>
              <div>
                <p className="flex items-center gap-2 eyebrow text-[color:var(--bp-teal)]"><b.icon className="h-4 w-4" /> {b.label}</p>
                <p className="mt-4 text-[16px] leading-[1.85] text-[color:var(--bp-text-muted)]">{c[b.key]}</p>
              </div>
            </Reveal>
          ))}
          <div className="flex items-center gap-2 border-t border-[color:var(--bp-border)] pt-8">
            <Link to="/case-studies" className="inline-flex items-center gap-2 text-[14px] font-medium text-[color:var(--bp-teal)]"><ArrowLeft className="h-4 w-4" /> All case studies</Link>
          </div>
        </div>
      </section>

      <CTABand title="Discuss a similar mandate, in confidence." />
    </div>
  );
}
